<template>
  <section class="clients">
    <div class="container">
      <div class="clients-list">
        <flickity ref="flickity" :options="flickityOptions">
          <div class="clients-list__item">
            <img src="../../assets/images/clients/toyota.svg">
          </div>
          <div class="clients-list__item">
            <img src="../../assets/images/clients/mobigo.svg">
          </div>
          <div class="clients-list__item">
            <img src="../../assets/images/clients/aupair-options.svg">
          </div>
          <div class="clients-list__item">
            <img src="../../assets/images/clients/btn.svg">
          </div>
          <div class="clients-list__item">
            <img src="../../assets/images/clients/barberton-xcm.svg">
          </div>
          <div class="clients-list__item">
            <img src="../../assets/images/clients/anina-coetzee.svg">
          </div>
          <div class="clients-list__item">
            <img src="../../assets/images/clients/fsmp.svg">
          </div>
          <div class="clients-list__item">
            <img src="../../assets/images/clients/rotary-international.svg">
          </div>
          <div class="clients-list__item">
            <img src="../../assets/images/clients/barberton-kleuterskool.svg">
          </div>
          <div class="clients-list__item">
            <img src="../../assets/images/clients/mopani-pharmacy.svg">
          </div>
        </flickity>
      </div>
    </div>
  </section>
</template>

<script>
import Flickity from 'vue-flickity'
export default {
  components: {
    Flickity
  },
  data () {
    return {
      flickityOptions: {
        autoPlay: 4000,
        initialIndex: 0,
        prevNextButtons: false,
        pageDots: false,
        wrapAround: true
      }
    }
  }
}
</script>

<style lang="scss">
@import "../../assets/styles/breakpoints";
@import '../../assets/styles/variables';
.clients {
  margin-bottom: 100px;
  @include breakpoint(md) {
    margin-bottom: 75px;
  }
  .clients-list {
    width: 100%;
    margin-bottom: 30px;
    padding-bottom: 30px;
    border-bottom: 1px solid rgba($sage, 0.5%);
    .clients-list__item {
      width: 33.33%;
      height: 50px;
      display: flex;
      height: 60px;
      justify-content: center;
      align-items: center;
      @include breakpoint(md) {
        width: 50;
        img {
          display: block;
          height: 75%;
        }
      }
      @include breakpoint(sm) {
        width: 100%;
      }
      img {
        max-height: 60px;
        @include breakpoint(sm) {
         max-height: 50px;
        }
      }
    }

    .clients-list__item {

    }
  }
}
</style>
